import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../services/api'

const fetchControleIlustracao = async ({ pedido, compre_ganhe, modelo_arte }) => {
  const response = await api.get('/site/v2/fluxo-layout/listar-controle-ilustracoes', {
    params: {
      numero_pedido: pedido,
      compre_ganhe,
      modelo_arte,
    },
  })

  if (response.status !== 200) {
    throw new Error('Erro ao buscar os dados')
  }

  const lista = response.data

  return lista
}

const fetchModelosArtes = async () => {
  const res = await api.get('/site/v2/fluxo-layout/lista-contagem-modelos')

  return res.data
}

async function updateItems(data) {
  const response = await api.put('/site/v2/fluxo-layout/atualiza-fechamento-arquivo', data)

  return response.data
}

export const useControleIlustracao = (formValues) => {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: ['controle-ilustracao', formValues],
    queryFn: () => fetchControleIlustracao({ ...formValues }),
    refetchOnWindowFocus: false,
  })

  const mutation = useMutation(updateItems, {
    onSuccess: () => {
      queryClient.invalidateQueries(['controle-ilustracao', formValues])
    },
  })

  const modelos = useQuery({
    queryKey: 'modelos-arte-disponveis',
    queryFn: fetchModelosArtes,
    refetchOnWindowFocus: false,
  })

  return { query, mutation, modelos }
}
